// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-code[data-v-2d9e78db] {\n  width: 100%;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  min-height: 200px;\n  padding: 2px 20px 2px 20px;\n  background-color: #000000;\n  color: #26e43e;\n}\n", ""]);
// Exports
module.exports = exports;
